import { render, staticRenderFns } from "./NavigationMobile.vue?vue&type=template&id=2a501132&scoped=true&"
import script from "./NavigationMobile.vue?vue&type=script&lang=js&"
export * from "./NavigationMobile.vue?vue&type=script&lang=js&"
import style0 from "./NavigationMobile.vue?vue&type=style&index=0&id=2a501132&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a501132",
  null
  
)

export default component.exports